import request from '@/utils/request'
// import qs from 'qs'

// 分页查看所有目录
export const catalogList = (getData) => {
  return request({
    url: '/back/train-info/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    // data: postData
    params: getData
  })
}
// 删除目录
export const deleteCatalog = (getData) => {
  return request({
    url: '/back/train-info/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改目录
export const updateCatalog = (postData) => {
  return request({
    url: '/back/train-info/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 查看目录详情
export const getCatalog = (getData) => {
  return request({
    url: '/back/train-info/getTrainInfo',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 新增目录
export const addCatalog = (postData) => {
  return request({
    url: '/back/train-info/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 上传附件
export const uploadFile = (postData) => {
  return request({
    url: '/back/train-attachment/upload',
    method: 'post',
    headers: {
      'content-type': 'multipart/form-data'
    },
    data: postData
  })
}
// 修改附件
export const uploadUrl = (getData) => {
  return request({
    url: '/back/train-info/uploadUrl',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 文件列表
export const fileList = (postData) => {
  return request({
    url: '/back/train-attachment/list',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 修改目录下的文件
export const updateFile = (postData) => {
  return request({
    url: '/back/train-attachment/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 保存目录下的文件
export const addFile = (postData) => {
  return request({
    url: '/back/train-attachment/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 根据主键id删除文件内容
export const deleteFile = (getData) => {
  return request({
    url: '/back/train-attachment/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 附件状态改变
export const updateStatus = (getData) => {
  return request({
    url: '/back/train-attachment/updateStatus',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 目录状态改变
export const updateInfoStatus = (getData) => {
  return request({
    url: '/back/train-info/updateStatus',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
